import { GlobalErrorBoundary } from '@/features/errors/GlobalErrorBoundary';
import { useGlobalContainerRef, useGlobalRefs } from '@/wc/helper/ref';
import { App } from '@features/apps';
import {
  NotificationProvider,
  ToastProvider,
  useNotificationHolder,
  useToast,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { Outlet } from 'react-router-dom';
import styles from './_app.module.scss';

const cx = classnames.bind(styles);

export default function _App() {
  const globalRefs = useGlobalRefs();
  const containerRef = useGlobalContainerRef();
  const [api, contextHolder] = useNotificationHolder({
    isEndPause: undefined,
    isStartPause: undefined,
    getContainer: containerRef,
  });
  const [toastApi, toastContextHolder] = useToast();
  return (
    <section
      ref={globalRefs.globalSectionRef}
      className={cx(styles['section'])}
    >
      <main ref={globalRefs.globalMainRef} className={cx(styles['main'])}>
        <App>
          <GlobalErrorBoundary>
            <NotificationProvider value={api} contextHolder={contextHolder}>
              <ToastProvider
                value={toastApi}
                contextHolder={toastContextHolder}
              >
                <Outlet />
              </ToastProvider>
            </NotificationProvider>
          </GlobalErrorBoundary>
        </App>
      </main>
    </section>
  );
}
